module.exports = __webpack_public_path__ + "img/private-person.2ad0db79.svg";